import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
//
import { allLangs, defaultLang } from './config-lang';
import { useSettingsContext } from 'contexts/settings-context';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t } = useTranslation();

  const settings = useSettingsContext();

  const currentLang = allLangs.find((lang) => lang.value === settings.lang) || defaultLang;

  const onChangeLang = useCallback(
    (newlang: string) => {
      i18n.changeLanguage(newlang);
      settings.onChangeDirectionByLang(newlang);
    },
    [i18n, settings]
  );

  return {
    allLangs,
    t,
    currentLang,
    onChangeLang,
  };
}
